import { CatalogRouting } from '@aipb/gulliver/catalog/routing';
import { ROUTE_CATEGORY_DETAIL } from '@aipb/gulliver/catalog/util';
import { FrameRepository, FrameService } from '@aipb/gulliver/frame/data-access';
import { SnackbarService } from '@aipb/shared/util/snackbar';
import { UseCase } from '@aipb/shared/util/usecase';
import { inject, Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

interface PinRecord {
  id: string;
  label: string;
}

@Injectable({
  providedIn: 'root'
})
export class PinRecordUseCase implements UseCase<PinRecord> {
  private frame = inject(FrameService);
  private frameRepository = inject(FrameRepository);
  private catalogRouting = inject(CatalogRouting);
  private snackbar = inject(SnackbarService);
  private transloco = inject(TranslocoService);

  execute(data: PinRecord) {
    const url = this.catalogRouting.detailSingleRouteUrl(data.id);

    this.catalogRouting.detailSingle(data.id);

    if (this.frameRepository.hasDynamicRoute(url)) {
      this.snackbar.open(
        this.transloco.translate('catalog.messages.record_already_pinned', {
          value: data.label
        }),
        'warn'
      );
      return;
    }

    this.frame.addDynamicRoute({
      category: ROUTE_CATEGORY_DETAIL,
      label: data.label,
      url: this.catalogRouting.detailSingleRouteUrl(data.id)
    });
  }
}
